<!-- Header section following F8916 pattern -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa" 
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}" 
       style="margin-right: 10px; cursor: pointer;" 
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Body with tabs following F8916 pattern -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  <ul class="nav nav-pills" role="tablist">
    @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
      <a (click)="activeTab = tab.id" style="cursor: pointer;" class="btn-sm">
        {{ tab.name }}
      </a>
    </li>
}
  </ul>

  <div class="tab-content">
    <!-- Form Entry Tab -->
    @if (activeTab === 1) {
<div class="tab-pane active">
      <div class="form-horizontal">
            @if (showFormLoader) {
<div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}
    
    @if (!showFormLoader) {
<div>
          <!-- Entity information table -->
          <table class="table table-bordered form-inline enityDetails custom-table">
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.key }}</span>
              </td>
}
            </tr>
            <tr>
              @for (item of entityList; track $index) {
<td>
                <span>{{ item.value }}</span>
              </td>
}
            </tr>
          </table>

          <table style="width: 100%; border: 0px;" class="custom-table">
            <tbody>
              <tr>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>
                  <table style="width: 100%;" class="custom-table">
                    <tbody>
                      <tr>
                        <td class="BlackSmHdrBC">
                          {{ formHeader[0]?.DESCRIPTION }}
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                      </tr>
                    </tbody>
                  </table>
                  
                  <div class="table-scroll"> 
                    <table class="table table-bordered form-inline customTable custom-table">
                      <thead>
                        <!-- TABLE 1 -->
                        <tr>
                          <th class="sticky-col">{{ tableHeader[0]?.LINE_NO }}</th>
                          <th class="sticky-col">{{ tableHeader[0]?.DESCRIPTION }}</th>
                          @for (val of tableHeader; track itemTracker($index, val)) {
<th class="sticky-col">
                            {{ val.ATTRIB_DESCRIPTION }}
                          </th>
}
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of outerList; track itemTracker(i, row); let i = $index) {
<tr 
                            class="table1"
                            [style.display]="row.IS_FORM_DISPLAY === 'Y' ? '' : 'none'">
                          
                          <!-- Line number display -->
                          @if (row.ROW_TYPE != 'PH') {
<td>{{ row.LINE_DISP }}</td>
}
                          @if (row.ROW_TYPE == 'PH') {
<td 
                              [ngClass]="{'color-red': row.ROW_TYPE == 'PH'}">
                            <b>{{ row.LINE_DISP }}</b>
                          </td>
}
                          
                          <!-- Description column -->
                          @if (row.ROW_TYPE == 'PH') {
<td 
                              [ngClass]="{'color-red': row.ROW_TYPE == 'PH'}">
                            <span><b>{{ row.DESCRIPTION }}</b></span>
                          </td>
}
                          @if (row.ROW_TYPE != 'PH') {
<td>{{ row.DESCRIPTION }}</td>
}
                          
                          <!-- Dynamic columns for each form list item -->
                          @for (row1 of formList; track itemTracker(j, row1); let j = $index) {
<td style="width: 220px;" 
                             
                              [style.display]="row1.IS_FORM_DISPLAY === 'Y' && row1.FORM_LINE_KEY === row.FORM_LINE_KEY && row1.EDIT_TYPE != 'radio' ? '' : 'none'">
                            
                                                         <!-- Non-editable display -->
                             @if (row1.IS_EDITABLE_CELL == 'N' && row1.EDIT_TYPE != 'radio') {
<div style="text-align: right; padding-right: 10px" 
                                  
                                  [ngClass]="{'color-red': row1.ATTRIB_VALUE < 0}">
                               <span>{{ row1.ATTRIB_VALUE | number }}</span>
                             </div>
}
                            
                            <!-- Editable inputs -->
                            @if (row1.IS_EDITABLE_CELL == 'Y') {
<div style="text-align: right; padding-right: 10px" 
                                >
                              
                              <!-- Number input -->
                              @if (row1.DATA_TYPE == 'number') {
<div>
                                <input class="form-control input-md numText"
                                       [ngClass]="{'color-red': row1.ATTRIB_VALUE < 0}" 
                                       style="text-align: right" 
                                       type="text"
                                       [(ngModel)]="row1.ATTRIB_VALUE"
                                       [disabled]="row1.is_editable"
                                       placeholder=""
                                       aria-describedby="basic-addon2"
                                       (ngModelChange)="validateSubForm(row1)">
                              </div>
}
                              
                              <!-- String input -->
                              @if (row1.DATA_TYPE == 'string') {
<div>
                                <input class="form-control input-md numText"
                                       style="text-align: right" 
                                       type="text"
                                       [(ngModel)]="row1.ATTRIB_VALUE"
                                       [disabled]="row1.is_editable"
                                       placeholder=""
                                       aria-describedby="basic-addon2"
                                       (ngModelChange)="validateSubForm(row1)">
                              </div>
}
                            </div>
}
                          </td>
}
                        </tr>
}
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
}
  </div>
</div>

<!-- Footer buttons following F8916 pattern -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button 
          class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save and Proceed
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button 
          class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
}
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div> 